
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.4 18.7c-1.7-1.6-1.8-4.2-.4-6L12.8 5c1.4-1.4 3.6-1.4 5 0 1.3 1.3 1.4 3.4.1 4.7l-.1.1-7.4 7.2c-1 1-2.4 1-3.3.1s-.9-2.3-.1-3.2l.1-.1 6.2-6c.2-.2.6-.2.8 0s.2.6 0 .8l-6.2 6c-.4.4-.5 1.1 0 1.6.5.4 1.2.4 1.6 0L16.9 9c.9-.9.9-2.3.1-3.2l-.1-.1c-.9-.9-2.4-.9-3.3 0L6.2 13c-1.3 1.3-1.4 3.4-.1 4.7l.1.1c1.4 1.4 3.6 1.4 5 0l7.8-7.6c.2-.2.6-.2.8 0 .2.2.2.6 0 .8l-8.3 8c-1.8 1.4-4.4 1.3-6.1-.3z"}})])
          )
        }
      }
    